import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import Button from "components/button";
import { getVoucherMeta } from "variables/constants";
import { 
    getMerchantDetails, 
    doAddToCart,
} from "../../../../redux/hyvidstore/hyvidStoreState";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { displayIcon } from "variables/icons";

const VoucherDetails = ({ merchantId, voucherData, onClose, showDescription=true }) => {
    // if (!merchantId) return null;

    const dispatch = useDispatch();
    const merchant = useSelector((state) => state.hyvidStore.merchantDetails.data);
    const requesting = useSelector((state) => state.hyvidStore.merchantDetails.requesting);
    const [selectedDenomination, setSelectedDenomination] = useState(null);

    useEffect(() => {
        if(merchantId){
            setSelectedDenomination(null);
            dispatch(getMerchantDetails({merchantId}));
        }
    },[dispatch, merchantId]);

    const handleAddToCart = () => {
        dispatch(doAddToCart({ cart_items: [{
            cri_product_id: selectedDenomination.denomination_id,
            cri_type_id: 0,
            cri_quantity: 1,
            cri_price: selectedDenomination.price,
            cri_price_total: selectedDenomination.price,
        }]
        }));
      };

    const isTrending = true;

    const { icon: Icon, gradientFrom, gradientTo } = getVoucherMeta(voucherData?.category);

    if(requesting){
        return (
            <Card className="bg-white grid w-full gap-4 rounded-xl border p-6 shadow-lg duration-200 dark-mode-card">
                <div className="flex flex-col gap-2 text-center sm:text-left">
                    <h2 className="text-lg leading-none font-semibold">
                        {voucherData?.name}
                    </h2>
                    <p className="muted-text text-sm">
                        {voucherData?.tagline}
                    </p>
                </div>
                {showDescription &&
                <div className="h-30 space-y-4 py-4 rounded-xl overflow-hidden">
                    <div className={`h-40 rounded-xl bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center`}>
                        {Icon && <Icon className="w-20 h-20 text-white opacity-90" />}
                    </div>
                </div>
                }
            </Card>
        )
    }

    return (
        <Card className="bg-white grid w-full gap-4 rounded-xl border p-6 shadow-lg duration-200 dark-mode-card">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <h2 className="text-lg leading-none font-semibold">
                    {merchant?.name}
                </h2>
                <p className="muted-text text-sm">
                    {merchant?.tagline}
                </p>
            </div>
            {showDescription && <>
            <div className="h-30 space-y-4 py-4 rounded-xl overflow-hidden">
                <div className={`h-40 rounded-xl bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center`}>
                    {Icon && <Icon className="w-20 h-20 text-white opacity-90" />}
                    <img src={merchant?.cover_url} alt="voucher_cover" />
                </div>
            </div>
            
            <div>
                <h4 className="font-medium mb-2">
                    Description
                </h4>
                <div className="max-h-[150px] overflow-y-auto">
                    <ReactMarkdown
                        children={merchant?.fine_print}
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw, rehypeSanitize]}
                    />
                </div>
            </div>
            </>
            }
            <div className="grid grid-cols-2 gap-4 max-h-[230px] overflow-y-auto p-1">
                {merchant?.denominations.map((denomination) => {
                    const isSelected = selectedDenomination?.denomination_id === denomination.denomination_id; 
                    return (
                        <div 
                            key={denomination.denomination_id}
                            onClick={() => setSelectedDenomination(denomination)}
                            className={`
                                border rounded-lg p-2 cursor-pointer
                                transition-all duration-200
                                ${
                                    isSelected
                                        ? "border-primary bg-blue-200 ring-2 ring-primary"
                                        : "border-gray-200 bg-gray-100 hover:border-gray-400"
                                }
                            `}
                        >
                            <p className="text-[12px] font-bold mb-1">
                                {denomination.name}
                            </p>
                            <p className="text-[12px] muted-text">
                                {denomination.short_description}
                            </p>
                            <p className="text-[12px] muted-text ">
                                Valid for {denomination.days_valid} days
                            </p>
                        </div>
                        );
                    }
                )}
                {/* <div>
                    <p className="text-[12px] muted-text mb-1">
                        {name}
                    </p>
                    <p className="text-[18px] font-bold">
                        {merchant?.minimum_denomination_value} - {merchant?.maximum_denomination_value}
                    </p>
                </div>
                <div>
                    <p className="text-[12px] muted-text mb-1">
                        Points Required
                    </p>
                    <p className="text-[18px] font-bold text-emerald-600 dark:text-emerald-500 flex items-center gap-1">
                        <Sparkles className="w-5 h-5" />
                        {merchant?.minimum_denomination_value} - {merchant?.maximum_denomination_value}
                    </p>
                </div> */}
            </div>
            {isTrending && (
                <span className="justify-center rounded-xl px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 transition-[color,box-shadow] bg-gradient-to-r from-orange-500 to-pink-500 text-white border-0 flex items-center gap-1">
                    { displayIcon("Trophy","w-3 h-3")}
                    Trending Voucher!
                </span>
            )}
            <div className="flex gap-2">
                <Button
                    onClick={onClose}
                    className="flex-1 h-8 border rounded-lg text-sm flex items-center justify-center hover:shadow-none hover:bg-slate-100"
                >
                    Close
                </Button>

                <Button
                    disabled={!selectedDenomination}
                    onClick={() => {handleAddToCart(); 
                        if (onClose) onClose();  
                    }}
                    className={`inline-flex items-center justify-center whitespace-nowrap text-sm 
                        font-medium outline-none h-8 rounded-md gap-1.5 px-3 flex-1 
                        ${selectedDenomination ? 
                            "bg-gradient-to-r from-emerald-600 to-purple-600 hover:from-emerald-700 hover:to-purple-700 hover:shadow-none text-white" 
                            : "disabled bg-gradient-to-r from-gray-200 to-gray-200 "}
                        `}
                >
                    { displayIcon("ShoppingCart","w-4 h-4 mr-1")}
                    Add to Cart
                </Button>
            </div>
        </Card>
    )
};
export default VoucherDetails;